import React, { useEffect } from 'react';
import classes from './Portrfolio.module.css';
import Navigation from '../../Components/Navigation/Navigation'
import Footer from '../../Components/Footer/Footer'
import imgprtflio from '../../Assets/ourworkprtflio.png'
import imgprtfliomble from '../../Assets/mblrprtflio.png'
import prj1img from '../../Assets/frstprtfolioimg.png'
import prj1imgii from '../../Assets/sndprtfolioimg.png'
import Getstarted from '../../Components/Get started/Getstarted'

const Portfolio = () => {


  useEffect(() => {
    window.scrollTo(0, 0);
}, []);

  return (
    <div div className={classes.landingPage}>
      <Navigation />
      <section>
        <p className={`${classes.ourwrk} ${classes.fadeIn}`}>Our Work Speaks for Itself</p>
        <p className={`${classes.ourwksmltxt} ${classes.fadeInDelay}`}>View our works reflecting the unique solutions we have provided for our clients diverse needs</p>
        <img src={imgprtflio} className={`${classes.imgshi} ${classes.fadeIn}`} />
        <img src={imgprtfliomble} className={`${classes.imgshii} ${classes.fadeInDelay}`} />
      </section>
      <section>
        <p className={classes.ourprjcts}>Our Projects</p>
        <div className={classes.ourprjctssmltxt}>
          <div>
            <img src={prj1img} className={classes.imgprtfl} />
            <div className={classes.imgsjh}>
              <p className={classes.imgsjhtxt}>Kinra</p>
              <button className={classes.wrkbtn}>Mobile App</button>
            </div>
          </div>
          <div>
            <img src={prj1imgii} className={classes.imgprtfl} />
            <div className={classes.imgsjh}>
              <p className={classes.imgsjhtxt}>Shoptttt</p>
              <button className={classes.wrkbtn}>Web App</button>
            </div>
          </div>
        </div>
        <div className={classes.ourprjctssmltxt}>
          <div>
            <img src={prj1imgii} className={classes.imgprtfl} />
            <div className={classes.imgsjh}>
              <p className={classes.imgsjhtxt}>Shoptttt</p>
              <button className={classes.wrkbtn}>Web App</button>
            </div>
          </div>
          <div>
            <img src={prj1img} className={classes.imgprtfl} />
            <div className={classes.imgsjh}>
              <p className={classes.imgsjhtxt}>Kinra</p>
              <button className={classes.wrkbtn}>Mobile App</button>
            </div>
          </div>
        </div>
        <div className={classes.ourprjctssmltxt}>
          <div>
            <img src={prj1img} className={classes.imgprtfl} />
            <div className={classes.imgsjh}>
              <p className={classes.imgsjhtxt}>Kinra</p>
              <button className={classes.wrkbtn}>Mobile App</button>
            </div>
          </div>
          <div>
            <img src={prj1imgii} className={classes.imgprtfl} />
            <div className={classes.imgsjh}>
              <p className={classes.imgsjhtxt}>Shoptttt</p>
              <button className={classes.wrkbtn}>Web App</button>
            </div>
          </div>
        </div>
      </section>
<Getstarted />

      <Footer />
    </div>
  );
}

export default Portfolio;
